import { initialResourcesState, IResourcesState} from "../../state/resources/resources.state";
import {EResourcesActions, ResourcesActions} from "../../actions/resources/resources.actions";
import {emptyResource, IResource} from "@retail-data-factory/rdf-angular-types-api";

export const resourcesReducers = (
  state = initialResourcesState,
  action: ResourcesActions
):IResourcesState =>{
  switch (action.type) {
    case EResourcesActions.GetResources: {
      return {
        ...state
      };
    }
    case EResourcesActions.GetResourcesSuccess: {
      return {
        ...state,
        data: action.payload,
        isLoaded:true
      };
    }
    case EResourcesActions.GetResourcesFailure: {
      return {
        ...state,
        //data: [],
        data: {
          resources:[],
          resourceGroups:[],
        },
        isLoaded:false
      };
    }

    case EResourcesActions.UpdateResource: {
      const resource = state.data.resources.find(t=>t.id === action.payload.id);
      if (resource) {
        resource.profile = action.payload.profile;
        resource.code = action.payload.code;
        resource.url = action.payload.url;
        resource.groupCode = action.payload.groupCode;
        resource.type = action.payload.type;
        resource.name = action.payload.name;
        resource.description = action.payload.description;
        resource.groupName = action.payload.groupName;
        resource.img = action.payload.img;
        return {...state};
      } else {
        return state;
      }
    }

    default:
      return state;
  }
};


export const currentResourceReducers = (
  state = emptyResource,
  action: ResourcesActions
):IResource =>{
  switch (action.type) {
    case EResourcesActions.SetCurrentResource: {
      return state;
    }
    case EResourcesActions.SetCurrentResourceSuccess: {
      return action.payload;
    }
    case EResourcesActions.GetResourcesFailure: {
      return state;
    }
    default:
      return state;
  }
};
